
// src/web/components/bidirectonal-infinite-scroll.jsx

import React, {
  PureComponent,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'

export default class BidirectinalInfiniteScroll extends PureComponent {
  static propTypes = {
    element: PropTypes.string,
    load: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]).isRequired,
    threshold: PropTypes.number,
    hasBefore: PropTypes.bool,
    hasAfter: PropTypes.bool,
  };

  static defaultProps = {
    element: 'div',
    threshold: 1,
  };

  constructor(props) {
    super(props);

    this.load = _.debounce(this.props.load, 100)
    //this.load = this.props.load
    this.scrollListener = this.scrollListener.bind(this);
  }

  componentDidMount() {
    this.scrollWindow = this.scrollComponent.parentNode;
    this.attachScrollListener();
  }

  UNSAFE_componentWillUpdate() {
    var scrollEl = this.scrollComponent.parentNode;
    this.scrollHeight = scrollEl.scrollHeight;
    this.scrollTop = scrollEl.scrollTop;
  }

  componentDidUpdate(prevProps) {
    this.attachScrollListener();
    var scrollEl = this.scrollComponent.parentNode;

    if (prevProps.children !== this.props.children) {
      //console.log(`didUpdate children:${this.props.children.length} direction:${this.direction} scrollTop:${this.scrollTop} new scrollHeight:${scrollEl.scrollHeight} old scrollHeight:${this.scrollHeight}`, scrollEl)
      if (this.direction < 0)
        scrollEl.scrollTop = this.scrollTop + (scrollEl.scrollHeight - this.scrollHeight);
      else
        scrollEl.scrollTop = this.scrollTop;
      //console.log('scrollTop', scrollEl.scrollTop)
    }
  }

  componentWillUnmount() {
    this.detachScrollListener();
  }

  detachScrollListener() {
    let scrollEl = this.scrollComponent.parentNode;

    scrollEl.removeEventListener('scroll', this.scrollListener);
    scrollEl.removeEventListener('resize', this.scrollListener);
  }

  attachScrollListener() {
    let scrollEl = this.scrollComponent.parentNode;
    if (!this.props.hasAfter && !this.props.hasBefore)
      return

    scrollEl.addEventListener('scroll', this.scrollListener);
    scrollEl.addEventListener('resize', this.scrollListener);

    this.scrollListener();
  }

  scrollListener() {
    const el = this.scrollComponent;
    let scrollEl = this.scrollComponent.parentNode;

    //console.log(`scrollListener scrollTop:${el.parentNode.scrollTop} clientHeight:${el.parentNode.clientHeight} scrollHeight:${el.scrollHeight}`)
    if (this.props.hasBefore && el.parentNode.scrollTop < this.props.threshold) {
      this.detachScrollListener();
      this.direction = -1
      this.load(-1)
    }
    if (this.props.hasAfter && el.scrollHeight - el.parentNode.scrollTop - el.parentNode.clientHeight < this.props.threshold) {
      this.detachScrollListener();
      this.direction = 1
      this.load(1)
    }
  }

  render() {
    const {
      children,
      element,
      load,
      threshold,
      ...props
    } = this.props;

    props.ref = (node) => {
      this.scrollComponent = node;
    };

    return React.createElement(
        element,
        props,
        children,
    );
  }
}



// WEBPACK FOOTER //
// ./src/web/components/bidirectional-infinite-scroll.jsx